import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.CoreSelectionDrawer, {
    attrs: {
      "has-search": "",
      "has-footer": "",
      "is-checked-variant": "",
      title: _vm.title,
      "title-truncate": _vm.titleTruncate,
      placeholder: _vm.placeholder,
      "is-back": _vm.isBack,
      value: _vm.value,
      items: _setup.specialities,
      "selected-item": _vm.selectedSpeciality,
      loading: _setup.loading,
      error: _setup.error,
      attach: ".vue-the-doctors-filters .v-application",
    },
    on: {
      input: function ($event) {
        return _vm.$emit("input", false)
      },
      back: function ($event) {
        return _vm.$emit("input", false)
      },
      "click-item": _setup.handleClickSpeciality,
    },
    scopedSlots: _vm._u(
      [
        {
          key: "append-header",
          fn: function () {
            return [
              _vm.selectedSpeciality && _vm.isVisibleReset
                ? _c(
                    VBtn,
                    {
                      staticClass: "ml-auto",
                      attrs: { color: "primary", small: "", text: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("speciality:reset")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_setup.t("Сбросить", _setup.options)) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        {
          key: "footer",
          fn: function () {
            return [
              _vm._t("footer", null, null, {
                selectedSpeciality: _vm.selectedSpeciality,
              }),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }